export type ReportInspectorState = {
    reportTab: 'reports' | 'formulas'
    page: number
    limit: number
    selectedSite: string
    showAllSites: boolean
    searchValue: string
    reportDetails: any
    joinDetails?: any
    formulasActiveTab: string | null
    reportsActiveTab: string | null
    formulaReportsPage: number
    showReportQuery: boolean
    editFields: boolean
    showCreateNewModal: boolean
    saveReportPending: boolean
    createNewModal?: 'report' | 'formula'
    selectedReportPk?: number
    selectedFormulaPk?: number
}

export type ReportInspectorAction =
    | { type: 'setReportTab', payload: 'reports' | 'formulas' }
    | { type: 'setPage', payload: number }
    | { type: 'setSelectedSite', payload: string }
    | { type: 'toggleShowAllSites' }
    | { type: 'setSearch', payload: string }
    | { type: 'setReportDetails', payload: any }
    | { type: 'toggleReportQueryResults' }
    | { type: 'setFormulasActiveTab', payload: string | null }
    | { type: 'setFormulaReportsPage', payload: number }
    | { type: 'setReportsActiveTab', payload: string | null }
    | { type: 'setJoinDetails', payload: any }
    | { type: 'setSelectedReportPk', payload: number | undefined }
    | { type: 'setSelectedFormulaPk', payload: number | undefined }
    | { type: 'selectAndViewFormula', payload: number | undefined }
    | { type: 'createNew', payload: 'report' | 'formula' }
    | { type: 'closeCreateNewModal' }
    | { type: 'newReportSaveSuccess', payload: number }
    | { type: 'toggleSaveReportPending' }
    | { type: 'toggleEditFields' }
    | { type: 'selectFormulaReport', payload: number }
    | { type: 'resetSearchState' }

export const initialState: ReportInspectorState = {
    reportTab: 'reports',
    page: 1,
    limit: 50,
    formulaReportsPage: 1,
    selectedSite: '',
    showAllSites: false,
    searchValue: '',
    joinDetails: undefined,
    reportDetails: null,
    showReportQuery: false,
    formulasActiveTab: 'details',
    reportsActiveTab: 'details',
    editFields: false,
    showCreateNewModal: false,
    createNewModal: undefined,
    saveReportPending: false,
    selectedReportPk: undefined,
    selectedFormulaPk: undefined,
}

export const reducer = (state: ReportInspectorState, action: ReportInspectorAction): ReportInspectorState => {
    switch (action.type) {
        case 'setReportTab':
            return { ...state, reportTab: action.payload, page: 1 }
        case 'setPage':
            return { ...state, page: action.payload }
        case 'setSelectedSite':
            return { ...initialState, showAllSites: state.showAllSites, reportTab: state.reportTab, selectedSite: action.payload, page: 1 }
        case 'toggleShowAllSites':
            return { ...state, showAllSites: !state.showAllSites, page: 1 }
        case 'setSearch':
            return { ...state, searchValue: action.payload }
        case 'setFormulasActiveTab':
            return { ...state, formulasActiveTab: action.payload }
        case 'setReportsActiveTab':
            return { ...state, reportsActiveTab: action.payload }
        case 'setReportDetails':
            return { ...state, reportDetails: action.payload }
        case 'setSelectedReportPk':
            return { ...state, selectedReportPk: action.payload }
        case 'setJoinDetails':
            return { ...state, joinDetails: action.payload }
        case 'setFormulaReportsPage':
            return { ...state, formulaReportsPage: action.payload }
        case 'toggleReportQueryResults':
            return { ...state, showReportQuery: !state.showReportQuery }
        case 'setSelectedFormulaPk':
            return { ...state, selectedFormulaPk: action.payload }
        case 'selectFormulaReport':
            return { ...state, selectedReportPk: action.payload, reportTab: 'reports' }
        case 'toggleEditFields':
            return { ...state, editFields: !state.editFields }
        case 'createNew':
            return { ...state, showCreateNewModal: true, createNewModal: action.payload }
        case 'toggleSaveReportPending':
            return { ...state, saveReportPending: !state.saveReportPending }
        case 'newReportSaveSuccess':
            return { ...state, selectedReportPk: action.payload, showCreateNewModal: false, createNewModal: undefined, reportsActiveTab: 'reportFields' }
        case 'closeCreateNewModal':
            return { ...state, showCreateNewModal: false, createNewModal: undefined }
        case 'selectAndViewFormula':
            return { ...state, selectedFormulaPk: action.payload, reportTab: 'formulas' }
        case 'resetSearchState':
            return { ...state, selectedFormulaPk: undefined, selectedReportPk: undefined }
        default: return state
    }
}